import TreeViewType from '../../constants/liquidation/TreeViewType';
import MouvementTreeView from '../mouvements/MouvementTreeView';
import type BaseTreeView from './BaseTreeView';

// biome-ignore lint/complexity/noStaticOnlyClass: Je ne sais pas pourquoi c'est en static
class TreeViewFactory {
	static newInstance(type: TreeViewType): BaseTreeView {
		switch (type) {
			case TreeViewType.MOUVEMENT:
				return new MouvementTreeView();
			default:
				return null;
		}
	}
}

export default TreeViewFactory;
